import $ from 'jquery';
import { Dialog } from 'material-ui';
import moment from 'moment';
import { saveActivity} from '../../common/commonService.js'
import InputDatePicker from 'mygame-components/dist/DatePicker/InputDatePicker';
import React from 'react';
import { apiService } from '../../common/apiCallService';
import { baseUrl } from '../../common/config';
class MyGameMessenger extends React.Component {

    state = { messenger: { page: 'chat' }, showDatePicker: false, view: 'form' }

    handleInputChange = e => {
        const { messenger } = this.state
        messenger[e.target.name] = e.target.value
        this.setState({ messenger, showDatePicker: e.target.name === 'scheduleTime' })
    }

    sendMessage = () => {
        const { messenger, scheduleTimeError } = this.state
    let track = {}
    track.hit_page = 'MyGameMessenger';
    track.hit_type = 'SendMessage';
    track.hit_attribute1 = localStorage.getItem("username");
    track.hit_attribute2 = messenger.accountName;
    track.hit_attribute3 = messenger.page;
    track.hit_attribute4 = messenger.message;
    track.hit_player = messenger.accountName;
    saveActivity(track);
        
        
        console.log("messenger",messenger);
        if (Object.keys(messenger).length < 3 || scheduleTimeError) {
            return
        }
        apiService(`${baseUrl}/whizEvent/sendMessageToPlayer`, messenger, (data) => {
            this.setState({ view: 'done' })
            setTimeout(() => {
                this.setState({ view: 'form', messenger: { page: 'chat' } })
                this.props.handleClose()
            }, 5000)
            return data
        }, (error) => {
            this.setState({ loading: false })
            console.log("Error:", error)
        })
    }

    render() {
        const { messenger, showDatePicker, tempScheduleTime, scheduleTimeError, view } = this.state
        const selectedFromDate = moment(tempScheduleTime || new Date())
        return (
            <Dialog
                contentStyle={{ width: 500, maxHeight: '600px', maxWidth: 'none', backgroundColor: 'white' }}
                bodyStyle={{ backgroundColor: "white", width: '511px', paddingTop: '5px' }}
                title={this.props.title}
                modal={true}
                open={this.props.open}
                onRequestClose={this.handleClose}
                autoScrollBodyContent={true}
            >
                {
                    view === 'done' ?
                        <div style={{ color: 'back', textAlign: 'center', margin: '3rem 0' }}>
                            <i className="fa fa-check-circle fa-5x" style={{ color: 'green' }}></i>
                            <div style={{ fontSize: '25px', fontWeight: '600', color: 'black' }}>Well done!</div>
                            <div style={{ fontSize: '17px', fontWeight: '300', color: 'black' }}>Message has been scheduled successfully</div>
                        </div>
                        :
                        <div>
                            <div style={{ color: 'black', marginTop: '0px' }}>
                                <h3>MyGame Messenger</h3>
                                <i className="fa fa-times" onClick={this.props.handleClose} style={{ "color": '#000000', marginTop: '10px', float: 'right' }} />
                            </div>
                            <div>
                                <span className="input-lable">Account Name</span>
                                <input type="text" name="accountName" className="form-control" style={{ width: '100%' }} placeholder="Account Name" value={messenger['accountName'] || ''} onChange={this.handleInputChange} />
                            </div>
                            <div>
                                <span className="input-lable">Message</span>
                                <textarea placeholder="Enter Message" className="form-control" name="message" value={messenger['message'] || ''} onChange={this.handleInputChange} />
                            </div>
                            <div>
                                <span className="input-lable">Render To</span>
                                <select className="form-control" onChange={this.handleInputChange} disabled={true} value={messenger['page']}>
                                    <option value="home">MyGame Homepage</option>
                                    <option value="chat">Whiz Chat Feed</option>
                                    <option value="livefeed" >Whiz Live Feed</option>
                                </select>
                            </div>
                            <div style={{ marginTop: '2rem', display: 'none' }}>
                                <div className="dp_date_picker_group" id="pw_dp_date_picker_group1" data-toggle="modal"
                                    data-target="#pWdpFromDateTimePicker">
                                    <div className="dp_lable">
                                        Time: <span className="date-error">{scheduleTimeError || ''}</span>
                                    </div>
                                    <div className="pw_team_selector_dropdown">
                                        <span className="pw_team_datepicker_text" data-e2e="from-date">
                                            {(showDatePicker) ? moment(tempScheduleTime).format("DD/MM/YYYY - hh:mmA") : <spam>DD/MM/YYYY{<span style={{ marginLeft: "5px", marginRight: "5px" }}>&#8212;</span>}HH/MM</spam>}
                                        </span>
                                    </div>
                                </div>
                                <InputDatePicker modalId="pWdpFromDateTimePicker" name="scheduleTime" selectedDate={selectedFromDate}
                                    handleChange={data => { this.setState({ tempScheduleTime: moment(data), scheduleTimeError: '' }) }}
                                    handleSave={() => {
                                        this.handleInputChange({ target: { name: 'scheduleTime', value: tempScheduleTime.valueOf() } })
                                        if (moment(moment(tempScheduleTime).format("YYYY-MM-DD HH:mm:ss")).isBefore(moment().startOf("day"))) {
                                            console.log('selected before date')
                                            this.setState({ scheduleTimeError: "Schedule time must before current time" })
                                        }
                                        $('#pw_dp_date_picker_group1').click();
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: '1rem' }}>
                                <button className="brandButton" style={{ width: '100%', height: '35px', textAlign: 'center', padding: '0px !important' }} onClick={this.sendMessage}>Send</button>
                            </div>
                        </div>
                }
            </Dialog >
        )
    }
}

export default MyGameMessenger


/** WEBPACK FOOTER **
 ** ./src/components/MyGameMessenger/index.jsx
 **/